import { FC, useContext, useMemo } from "react"
import ProjectsContext from "../contexts/data/ProjectsContext"
import { Navigate } from "react-router-dom";

interface IRedirectWithContextProps {
    variant: 'project'
}

const RedirectWithContext: FC<IRedirectWithContextProps> = ({
    variant
}) => {

    const {data: projects} = useContext(ProjectsContext);

    const to = useMemo(() => {
        switch(variant) {
            case 'project': 
                return projects && projects.length > 0 ? `/projects/${projects[0].id}` : "";
        }
    }, [variant, projects])
    

    return (
        <Navigate to={to} />
    );
}

export default RedirectWithContext;